const toIsoOrNull = value => {
	if (!value) return null
	const dt = new Date(value)
	if (Number.isNaN(dt.getTime())) return null
	return dt.toISOString()
}

const maxIso = values => {
	const list = values
		.map(toIsoOrNull)
		.filter(Boolean)
		.map(v => new Date(v).getTime())
	if (!list.length) return null
	return new Date(Math.max(...list)).toISOString()
}

export const buildTaskFreshnessMeta = task => ({
	taskLastUpdatedAt: maxIso([
		task?.submission_date,
		task?.completed_at,
		task?.updated_at,
	]),
	quizLastLoadedAt: null,
	profileLastLoadedAt: null,
	lastKnownStatus: String(task?.student_status || '').trim() || null,
	lastFetchRequestId: null,
})

export const shouldRefetchDetails = ({
	type,
	meta,
	now = Date.now(),
	ttlMs = 10 * 60 * 1000,
}) => {
	if (type !== 'career_quiz' && type !== 'profile_building') return false
	const lastLoadedAtRaw =
		type === 'career_quiz' ? meta?.quizLastLoadedAt : meta?.profileLastLoadedAt
	if (!lastLoadedAtRaw) return true
	const lastLoadedAt = new Date(lastLoadedAtRaw).getTime()
	if (!Number.isFinite(lastLoadedAt)) return true
	const taskUpdatedAt = meta?.taskLastUpdatedAt
		? new Date(meta.taskLastUpdatedAt).getTime()
		: null
	if (Number.isFinite(taskUpdatedAt) && taskUpdatedAt > lastLoadedAt) return true
	return now - lastLoadedAt > ttlMs
}

export const buildTaskStudentKey = ({ taskId, studentId }) =>
	`${String(taskId || '').trim()}:${String(studentId || '').trim()}`

